import { render, staticRenderFns } from "./HtmlVideo.vue?vue&type=template&id=4cfa8400&scoped=true&"
import script from "./HtmlVideo.vue?vue&type=script&lang=js&"
export * from "./HtmlVideo.vue?vue&type=script&lang=js&"
import style0 from "./HtmlVideo.vue?vue&type=style&index=0&id=4cfa8400&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfa8400",
  null
  
)

export default component.exports